import { Game } from '@/app/game';
import { loadWorldTextures } from '@/render/textures';

const container = document.getElementById('game-container');
const hudRoot = document.getElementById('hud-root');
if (!container || !hudRoot) throw new Error('Missing #game-container / #hud-root');

const params = new URLSearchParams(window.location.search);

// Register the service worker in production builds served at the root scope
// (skipped on the /v2/ staging path so staging never hijacks the site scope)
if ('serviceWorker' in navigator && import.meta.env.PROD && import.meta.env.BASE_URL === '/') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}

// Textures load before world construction so toon conversion sees the maps;
// failures resolve to null and the world falls back to flat colors.
const textures = await loadWorldTextures();
const game = new Game(container, hudRoot, textures);

// Test facade for headless E2E (poll game state — game time ≠ wall time
// under SwiftShader). Enabled in dev builds or with ?test=1.
if (import.meta.env.DEV || params.get('test') === '1') {
  interface TestFacade {
    state: () => string;
    run: () => unknown;
    start: () => void;
    forceGameOver: () => void;
    positions: () => unknown;
  }
  (window as unknown as { __game: TestFacade }).__game = {
    state: () => game.fsm.state,
    run: () => ({ ...game.run }),
    start: () => game.startRun(),
    forceGameOver: () => game.endRun(),
    positions: () => game.debugPositions(),
  };
}
